var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "Bin_svg__a",
    d: "M0 0h18.632v4.508H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Bin_svg__c",
    d: "M.046.046h15.433V16.1H.046z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "Bin_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bin_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.744 1.932h-4.83A1.944 1.944 0 009.982 0H8.694a1.943 1.943 0 00-1.932 1.932h-4.83A1.944 1.944 0 000 3.864v.276c0 .207.16.368.368.368h17.894a.363.363 0 00.368-.368v-.276c.046-1.058-.805-1.932-1.886-1.932",
    fill: "#000",
    mask: "url(#Bin_svg__b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.61 5.75)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Bin_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Bin_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.324 4.393a.874.874 0 111.748 0v7.337a.874.874 0 11-1.748 0V4.393zm5.129 0a.874.874 0 111.748 0v7.337a.874.874 0 11-1.748 0V4.393zM.046 14.168c0 1.058.874 1.932 1.932 1.932h11.569a1.944 1.944 0 001.932-1.932V.046H.046v14.122z",
    fill: "#000",
    mask: "url(#Bin_svg__d)"
  })))));
}
export default SvgBin;